import { render, staticRenderFns } from "./MobilityPresetItem.vue?vue&type=template&id=4900f1fb&scoped=true"
import script from "./MobilityPresetItem.vue?vue&type=script&lang=js"
export * from "./MobilityPresetItem.vue?vue&type=script&lang=js"
import style0 from "./MobilityPresetItem.vue?vue&type=style&index=0&id=4900f1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900f1fb",
  null
  
)

export default component.exports